/**
 * SPM B 位终端段解析：pc / wap / app。
 *
 * App WebView 内嵌时（UA 含 nextmar-xms-app，服务端 deviceType 为 IOS/ANDROID），
 * 页面结构与 WAP 版一致，B 位按需求上报 <页面>_app 而非 <页面>_wap；C/D 坑位沿用
 * 同名 WAP 编码表（codes/*-app.ts 派生表）。PC 浏览器恒为 pc，其余移动浏览器为 wap。
 */
import { ZEELOOL_APP_UA_MARKER } from '@/utils/enums/app-sdk';
import { EPlatform } from '@/utils/enums/platform-enum';

export type SpmTerminalKind = 'pc' | 'wap' | 'app';

// UA 在整个会话内不变，缓存判断结果供渲染路径反复调用。
// 只依赖 UA 标记常量而非 isInZeloolApp()：大量单测对 @/utils/tools 做显式清单
// mock（vitest 对缺失导出抛错），SPM 渲染链路不应引入对它的运行时依赖。
let appEmbedCache: boolean | null = null;
function isAppEmbed(): boolean {
  if (appEmbedCache === null) {
    appEmbedCache =
      typeof navigator !== 'undefined' && navigator.userAgent.includes(ZEELOOL_APP_UA_MARKER);
  }
  return appEmbedCache;
}

/**
 * 解析当前终端段：WEB → pc；App 内嵌（服务端 deviceType 已判 IOS/ANDROID，
 * 客户端 UA 兜底识别）→ app；其余 → wap。deviceType 缺省时仅靠 UA 兜底，供
 * 只有「PC / 非 PC」语义的调用方（如按 isWeb 布尔选表的商详/列表埋点）使用。
 */
export function resolveSpmTerminalKind(deviceType?: EPlatform): SpmTerminalKind {
  if (deviceType === EPlatform.WEB) return 'pc';
  if (deviceType === EPlatform.IOS || deviceType === EPlatform.ANDROID) return 'app';
  return isAppEmbed() ? 'app' : 'wap';
}
